/** @format */

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { Locale } from "./init";

/**
 * To be used with React Router Dom to use the first URL param e.g. /en as the current locale.
 *
 * e.g. <Route path="/en" element={<LocaleWrapper locale="en"/>}> ... Child Routes ... </Route>
 */
const LocaleWrapper: React.FC<{ locale: Locale }> = ({ locale: urlLocale }) => {
  const { i18n } = useTranslation();

  /**
   * Set the language based on the incoming locale from the URL.
   */
  useEffect(() => {
    i18n.changeLanguage(urlLocale);
  }, [urlLocale, i18n]);

  /**
   * Output the child routes using the Outlet component.
   */
  return <Outlet />;
};

export default LocaleWrapper;
